export default __webpack_public_path__ + "static/media/sneakerTab.fce8bd12.png";